import { Button } from "@/components/ui/button";
import logo from "@/assets/logo.png";

export function Nav() {
  return (
    <header className="sticky top-0 z-50 w-full backdrop-blur-lg bg-background/80 border-b border-border/60">
      <div className="mx-auto max-w-7xl px-6 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2">
          <img src={logo} alt="Vox Campaign" className="h-9 w-auto" />
        </a>
        <nav className="hidden md:flex items-center gap-6 text-sm font-medium text-muted-foreground">
          <a href="#solucoes" className="hover:text-foreground transition-colors">Soluções</a>
          <a href="#comparativo" className="hover:text-foreground transition-colors">Comparativo</a>
          <a href="#como-funciona" className="hover:text-foreground transition-colors">Como funciona</a>
          <a href="#inteligencia" className="hover:text-foreground transition-colors">Inteligência</a>
          <a href="#service" className="hover:text-foreground transition-colors">Service</a>
          <a href="#planos" className="hover:text-foreground transition-colors">Planos</a>
        </nav>
        <div className="flex items-center gap-2">
          <Button asChild variant="ghost" className="hidden sm:inline-flex">
            <a href="/login">Vox App</a>
          </Button>
          <Button asChild className="bg-gradient-primary text-primary-foreground shadow-soft hover:opacity-95">
            <a href="#cta">Falar com especialista</a>
          </Button>
        </div>
      </div>
    </header>
  );
}
